import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isVisible }) => ({
  display: "none",
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.white,
  // FE-25: на iPhone с жестовой полосой нижний край уезжал под неё
  padding: `${theme.spacing(3)}px ${theme.spacing(4)}px max(${theme.spacing(3)}px, env(safe-area-inset-bottom))`,
  boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
  // Было 1000 — панель с ценой всплывала поверх модальных окон (у них 250).
  // Теперь она ниже модалок и дропдаунов, но выше контента.
  zIndex: theme.zIndex.header,
  flexDirection: "column",
  gap: 10,
  transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  transform: $isVisible ? "translateY(0)" : "translateY(100%)",
  opacity: $isVisible ? 1 : 0,
  pointerEvents: $isVisible ? "auto" : "none",

  [theme.down("lg")]: {
    display: "flex",
  },
}));

export const PriceText = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  "& .label": {
    fontSize: 14,
    color: theme.palette.text.muted,
  },

  "& .amount": {
    fontSize: 20,
    fontWeight: 700,
    // было #0052ff — синий, которого нет в палитре бренда
    color: theme.palette.text.primary,
    fontVariantNumeric: "tabular-nums",
  },
}));

export const Button = styled("button")(({ theme }) => ({
  width: "100%",
  padding: "14px 20px",
  backgroundColor: theme.palette.searchButtonBg,
  color: theme.palette.white,
  border: "none",
  borderRadius: theme.radii.md,
  fontSize: 16,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.3s ease",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.3,

  // FE-35: выключенная кнопка отличается не только прозрачностью
  "&:disabled": {
    backgroundColor: theme.palette.button.disabled,
    color: theme.palette.button.disabledText,
    cursor: "not-allowed",
  },

  "&:not(:disabled):hover": {
    filter: "brightness(90%)",
  },

  [theme.down("sm")]: {
    fontSize: 15,
    padding: "12px 16px",
  },

  [theme.down("xs")]: {
    fontSize: 14,
    padding: "12px 12px",
  },
}));

